import React, {useContext, useEffect, useState, useRef} from "react";
import {useNavigate, Link} from "react-router-dom";

import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";


const Header = () =>{

    const navigate = useNavigate();
    const {user, setUser} = useContext(AuthContext);
    const [showprofiledropdown, setShowProfileDropDown] = useState(false);
    const [loggedname, setLoggedName] = useState("");
    const profiledropdownRef = useRef(null);

    const dashboardurl = `${window.location.origin}/sales/dashboard`;

    useEffect(() =>{
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event)
        {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) 
            {
                setShowProfileDropDown(false);
            }
        }

    }, []);

    useEffect(()=>{

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, [])


    const handleShowProfileToggle = ()=>{
        setShowProfileDropDown(!showprofiledropdown);
    }

    const handleLogout = () =>{

        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);
        navigate('/sign-in', { replace: true });
    }

    return (
        <div className="header">
            <div className="header-left active">
                <Link to={dashboardurl} className="logo logo-normal img-logo">
                    <img src={logo} alt="Logo" />
                    {/*<img src="assets/img/white-logo.svg" className="white-logo" alt="Logo" />*/}
                </Link>
                {/*<Link to="index-2.html" className="logo-small">
                    <img src="assets/img/logo-small.svg" alt="Logo" />
                </Link>
                <Link id="toggle_btn" to="#">
                    <i className="ti ti-arrow-bar-to-left"></i>
                </Link>*/}
            </div>

            <Link id="mobile_btn" className="mobile_btn" to="#sidebar">
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>

            <div className="header-user">
                <ul className="nav user-menu">

                    <li className="nav-item nav-search-inputs me-auto">
                        
                    </li>

                    <li>
                        
                    </li>

                    <li className="nav-item nav-list">
                        <ul className="nav">
                            
                        </ul>
                    </li>

                    <li className="nav-item dropdown has-arrow main-drop">
                        <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center" ref={profiledropdownRef}>
                            <div className={showprofiledropdown ? "topbar-link drop-arrow-none position-relative show" : "topbar-link  drop-arrow-none position-relative"} onClick={handleShowProfileToggle} >
                                
                                <img src={userlogo} width="38" className="rounded-1 d-flex" alt="user-image" />

                                <span class="online text-success"><i class="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i></span>
                                
                            </div>

                            {showprofiledropdown ?
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2 show" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Caller</span>
                                    </div>
                                </div>

                                <Link to="/sales/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>

                                {/*<div class="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                                    <label class="form-check-label" for="notify"><i class="ti ti-bell"></i>Notifications</label>
                                    <input class="form-check-input me-0" type="checkbox" role="switch" id="notify" />
                                </div>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-help-circle me-1 align-middle"></i>
                                    <span class="align-middle">Help &amp; Support</span>
                                </Link>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-settings me-1 align-middle"></i>
                                    <span class="align-middle">Settings</span>
                                </Link>*/}            
                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            :
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Caller</span>
                                    </div>
                                </div>

                                <Link to="/sales/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>

                                {/*<div class="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                                    <label class="form-check-label" for="notify"><i class="ti ti-bell"></i>Notifications</label>
                                    <input class="form-check-input me-0" type="checkbox" role="switch" id="notify" />
                                </div>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-help-circle me-1 align-middle"></i>
                                    <span class="align-middle">Help &amp; Support</span>
                                </Link>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-settings me-1 align-middle"></i>
                                    <span class="align-middle">Settings</span>
                                </Link>*/}            
                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </li>
                    
                    {/*<li className="nav-item nav-item-email nav-item-box">
                        <div className="" style={{ cursor: "pointer" }} onClick={handleLogout}>
                            <svg  xmlns="http://www.w3.org/2000/svg"  width="34"  height="34"  viewBox="0 0 21 21"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-power">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                                <path d="M12 4l0 8" />
                            </svg>
                        </div>
                    </li>*/}

                    {/*<li className="nav-item dropdown nav-item-box">
                        <Link to="javascript:void(0);" className="nav-link" data-bs-toggle="dropdown">
                            <i className="ti ti-bell"></i>
                            <span className="badge rounded-pill">13</span>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end notification-dropdown">
                            <div className="topnav-dropdown-header">
                                <h4 className="notification-title">Notifications</h4>
                            </div>
                            <div className="noti-content">
                                <ul className="notification-list">
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img src="assets/img/profiles/avatar-02.jpg" alt="Profile" />
                                                    <span className="badge badge-info rounded-pill"></span>
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">Ray Arnold left 6 comments on Isla Nublar SOC2 compliance report</p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img src="assets/img/profiles/avatar-03.jpg" alt="Profile" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">Denise Nedry replied to Anna Srzand</p>
                                                    <p className="noti-sub-details">“Oh, I finished de-bugging the phones, but the system's compiling for eighteen minutes, or twenty.  So, some minor systems may go on and off for a while.”</p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img alt="" src="assets/img/profiles/avatar-06.jpg" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">John Hammond attached a file to Isla Nublar SOC2 compliance report</p>
                                                    <div className="noti-pdf">
                                                        <div className="noti-pdf-icon">
                                                            <span><i className="ti ti-chart-pie"></i></span>
                                                        </div>
                                                        <div className="noti-pdf-text">
                                                            <p>EY_review.pdf</p>
                                                            <span>2mb</span>
                                                        </div>
                                                    </div>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="topnav-dropdown-footer">
                                <Link to="activities.html" className="view-link">View all</Link>
                                <Link to="javascript:void(0);" className="clear-link">Clear all</Link>
                            </div>
                        </div>
                    </li>

                    <li className="nav-item dropdown has-arrow main-drop">
                        <Link to="#" className="nav-link userset" data-bs-toggle="dropdown">
                            <span className="user-info">
                                <span className="user-letter">
                                    <img src={userlogo} alt="Profile" />
                                </span>
                                <span className="badge badge-success rounded-pill"></span>
                            </span>
                        </Link>
                        <div className="dropdown-menu menu-drop-user">
                            <div className="profilename">
                                
                                <button className="dropdown-item" onClick={handleLogout}>
                                    <i className="ti ti-lock"></i> Logout
                                </button>
                            </div>
                        </div>
                    </li>*/}
                </ul>
            </div>

            {/*<div className="dropdown mobile-user-menu">
                <a href="javascript:void(0);" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fa fa-ellipsis-v"></i></a>
                <div className="dropdown-menu">
                    <a className="dropdown-item" href="index-2.html">
                        <i className="ti ti-layout-2"></i> Dashboard
                    </a>
                    <a className="dropdown-item" href="profile.html">
                        <i className="ti ti-user-pin"></i> My Profile
                    </a>
                    <a className="dropdown-item" href="login.html">
                        <i className="ti ti-lock"></i> Logout
                    </a>
                </div>
            </div>*/}
        </div>
    )

}

export default Header;